import { createNotificationContactThunk } from './createNotificationContactThunk';
export default createNotificationContactThunk;
